import {AOperation} from "../../models/operations/AOperation";
import {EOperationType} from "../../models/utils/EOperationType";
import {LatLng} from "leaflet";

/**
 * Service to obtain GPS coordinates from geolocated objects.
 * @author Alizée Grand
 * @version 1.0
 * @creation 05/01/2022
 * @last_update 05/01/2022
 **/
class GpsCoordinatesService {

    public generateGpsCoordinatesFromOperations(operations: AOperation[], filter?: EOperationType): LatLng[] {
        let coordinates: LatLng[] = [];
        let filteredOperations = operations;
        if(filter) {
            filteredOperations = operations.filter(operation => operation.type === filter);
        }
        for(let i = 0; i < filteredOperations.length; i++) {
            let location = this.generateGpsCoordinatesFromOperation(filteredOperations[i]);
            if(location !== undefined) {
                coordinates.push(location);
            }
        }
        return coordinates;
    }

    public generateGpsCoordinatesFromOperation(operation: AOperation): LatLng | undefined {
        return operation.geolocation !== undefined ? new LatLng(operation.geolocation.latitude, operation.geolocation.longitude) : undefined;
    }

}

export default new GpsCoordinatesService();
